/* Mak Beauty — ETA delivery badges
   Adds a class to <html> based on the current hour in America/Lima:
   - 01:00-16:59  -> mak-eta-hoy    (shows LLEGA HOY)
   - 17:00-00:59  -> mak-eta-manana (shows LLEGA MAÑANA)
   Re-evaluated every 5 minutes. */
(function () {
  function makEtaUpdate() {
    try {
      var raw = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Lima',
        hour: 'numeric',
        hour12: false
      }).format(new Date());
      var h = parseInt(raw, 10);
      if (h === 24) h = 0;
      var root = document.documentElement;
      root.classList.remove('mak-eta-hoy', 'mak-eta-manana');
      if (h >= 1 && h < 17) {
        root.classList.add('mak-eta-hoy');
      } else {
        root.classList.add('mak-eta-manana');
      }
    } catch (e) {}
  }
  makEtaUpdate();
  setInterval(makEtaUpdate, 300000);
})();